import { createSessionLifecycle } from '@mbbe/config';

/** Session lifecycle of the admin surface; driven by AuthProvider, observed by apiFetch and the QueryClient. */
export const adminSession = createSessionLifecycle();
